import { Injectable, Injector } from '@angular/core';
import { EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { AbstractRepositoryV2 } from '../../../../../core/service/v2/abstractRepositoryV2';
import { WorkflowTaskModel } from '../../../api/model/common/workflowTask.model';

@Injectable()
export class WorkflowTaskRepository extends AbstractRepositoryV2<WorkflowTaskModel> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('WorkflowTask', serviceElementsFactory, injector);
    }
}
